// removed by extract-text-webpack-plugin
module.exports = {"title":"_2mnnLd2O_TA7Kt9gjIPPC1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionTitle/SectionTitle.css
// module id = 180
// module chunks = 0